'use client';

import * as stylex from '@stylexjs/stylex';
import { Icon, IconProps } from '@/components/LucideIcon';
import { useState } from 'react';
import { useInterval } from 'usehooks-ts';
import '../styles/tokens.stylex';
import { spacing } from '../styles/tokens.stylex';
import { typography } from '../styles/typography';
type IconName = IconProps['name'];
type Item = {
  text: string;
  icon: IconName;
};
type MarqueeProps = {
  data?: Item[];
};
export function Marquee({
  data
}: MarqueeProps) {
  const [activeItemIndex, setActiveItemIndex] = useState(0);
  useInterval(() => {
    setActiveItemIndex(prev => (prev + 1) % (data?.length ?? 0));
  }, 4000);
  return data ? <ul className="x1ghz6dp x1717udv xe8uvvx xb3r6kr xrvj5dj">
      {data.map((item, index) => <li key={`${item.text}-${index}`} {...stylex.props(typography.small, sx.item, index === activeItemIndex && sx.itemActive)}>
          <span className="x16pmaob x6s0dn4 x78zum5 xl56j7k">
            <Icon name={item.icon} styles={sx.icon} />
            {item.text}
          </span>
        </li>)}
    </ul> : null;
}
const sx = {
  item: {
    kzIqYQ: "xd00j3c",
    kbNqZ1: "x1ms6mhf",
    kmkexE: "x1rsjlxy",
    k1xSpc: "x1s85apg",
    kWZpDQ: "xx1abn8",
    kEXP64: "xcrlgei",
    kSiTet: "xg01cxk",
    $$css: true
  },
  itemActive: {
    kmkexE: "x13mb9lf",
    k1xSpc: "x1lliihq",
    kSiTet: "x4itv7f xiiclqw",
    $$css: true
  },
  icon: {
    kjVXCG: "x73je2i",
    kZKoxP: "xlzyvqe",
    kzqmXN: "x15vhz18",
    $$css: true
  }
};